module.exports = __webpack_public_path__ + "img/collection-memoireRingsBestseller.2d8e7fa.webp";